/* PJC v10 — Panier : « Entrée » dans le champ de quantité valide la saisie (au lieu de soumettre le formulaire vers le paiement). */
import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keydown', this.#handleKeydown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('keydown', this.#handleKeydown);
  }

  /**
   * The quantity field sits inside the cart form, whose default button is the checkout button:
   * without this, pressing Enter after typing a quantity would jump to the payment step.
   * Blurring the field validates it through the existing `on:blur="/setQuantity"` handler.
   * @param {KeyboardEvent} event
   */
  #handleKeydown = (event) => {
    if (event.key !== 'Enter' || event.isComposing) return;
    if (event.target !== this.refs.quantityInput) return;

    event.preventDefault();
    this.refs.quantityInput.blur();
  };

  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are managed client-side, except when the line cannot be edited (disabled input: nested bundle line,
   * unavailable variant), where both stay disabled.
   */
  updateButtonStates() {
    const { minusButton, plusButton, quantityInput } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();
    const locked = quantityInput.disabled;

    minusButton.disabled = locked || value <= min;
    plusButton.disabled = locked || (effectiveMax !== null && value >= effectiveMax);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
